// 포인트 설정 섹션 URL (2026-08-25 KST 추가)
const pointSettingsSection = "/point-settings";

export const pointSettingsPath = pointSettingsSection;
